import axios from "axios";
import { AGENT_API_URL } from "../../config/config";
import { api_urls } from "../../utilities";
import { getAuthorizationHeader } from "./authHeader";

export const postAgentService = (
  api,
  data,
  showError = true,
  configuration = {}
) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      ...configuration,
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
  };

  return axios
    .post(AGENT_API_URL + api, data || {}, config)
    .then((res) => res)
    .catch((error) => {
      if (showError) {
        console.error(
          "[postAgentService]",
          AGENT_API_URL + api,
          error?.response || error
        );
      }
      throw error.response || error;
    });
};

export const postService = (
  api,
  data,
  showError = true,
  configuration = {}
) => {
  const authHeader = getAuthorizationHeader();
  const config = {
    headers: {
      ...configuration,
      token: api_urls.service_token,
      ...(authHeader ? { Authorization: authHeader } : {}),
    },
  };

  return axios
    .post(api_urls.base_url + api, data || {}, config)
    .then((res) => res)
    .catch((error) => {
      if (showError) {
        console.error("[postService]", api_urls.base_url + api, error?.response || error);
      }
      throw error.response || error;
    });
};
